import React, { useContext } from 'react';
import Layout, { LayoutProps } from 'src/components/Layout/Layout';
import { ChannelsPageLayoutHeaderContext } from 'src/components/Layout/ChannelsPageLayout/channelsLayoutHeaderContext';
import { ChannelsPageHeader } from 'src/components/Layout/ChannelsPageLayout/ChannelsPageHeader';
import { FlagsContext } from 'src/context';

export const ChannelsPageLayout: React.FC<LayoutProps> = ({
  children,
  title,
  ...others
}) => {
  // TODO(EnableChannelsLayoutRedesign): Remove these states
  const [createButtonProps, setCreateButtonProps] = React.useState(null);
  const [channelNewButtonProps, setChannelNewButtonProps] =
    React.useState(null);

  const [activeChannelTitle, setActiveChannelTitle] =
    React.useState<string>('');

  const [pageTitle, setPageTitle] = React.useState<string>(title || '');

  const [channelHeaderActions, setChannelHeaderActions] =
    React.useState<React.ReactNode | null>(null);

  const [channelHeaderMenuAnchorEl, setChannelHeaderMenuAnchorEl] =
    React.useState<null | HTMLElement>(null);

  /**
   * This state is used to hide the channels list toolbar when channels list has only one channel
   */
  const [channelsListToolbarHidden, setChannelsListToolbarHidden] =
    React.useState(true);

  /**
   * This state is used to hide the channels content toolbar
   */
  const [channelsContentToolbarHidden, setChannelsContentToolbarHidden] =
    React.useState(false);

  // TODO(EnableChannelsLayoutRedesign): Remove this context
  const channelsLayoutContextValue = React.useMemo(
    () => ({
      createButtonProps,
      setCreateButtonProps,
      activeChannelTitle,
      setActiveChannelTitle,
      channelHeaderActions,
      setChannelHeaderActions,
      channelHeaderMenuAnchorEl,
      setChannelHeaderMenuAnchorEl,
      channelsListToolbarHidden,
      setChannelsListToolbarHidden,
      pageTitle,
      setPageTitle,
      channelNewButtonProps,
      setChannelNewButtonProps,
      channelsContentToolbarHidden,
      setChannelsContentToolbarHidden,
    }),
    [
      createButtonProps,
      activeChannelTitle,
      channelHeaderActions,
      channelHeaderMenuAnchorEl,
      channelsListToolbarHidden,
      pageTitle,
      channelNewButtonProps,
    ],
  );

  const { EnableChannelsLayoutRedesign } = useContext(FlagsContext);

  return (
    <ChannelsPageLayoutHeaderContext.Provider
      value={channelsLayoutContextValue}
    >
      <Layout
        disableGutters={EnableChannelsLayoutRedesign}
        headerComponent={<ChannelsPageHeader />}
        hasNavbar={!EnableChannelsLayoutRedesign}
        {...others}
      >
        {children}
      </Layout>
    </ChannelsPageLayoutHeaderContext.Provider>
  );
};
